import { render, staticRenderFns } from "./vid.vue?vue&type=template&id=2bd3017e&scoped=true&"
import script from "./vid.vue?vue&type=script&lang=js&"
export * from "./vid.vue?vue&type=script&lang=js&"
import style0 from "./vid.vue?vue&type=style&index=0&id=2bd3017e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd3017e",
  null
  
)

export default component.exports